import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {isNullEmptyOrWhitespace} from "../../constants";

const formatTime = (value) => (value ? moment(value).format('DD/MM/YYYY LT') : null);

// Shows the live truck-proxy hub connection (the device connects to the cloud over its own link;
// the driver no longer needs the truck wifi). Weight / context / receipt come via SignalR.
const ScaleStatusView = (props) => {
    let {weightScales, truckNumberPlate, truckData} = props;
    const hubConnected = !!truckData?.connected;
    const scaleConnected = !!weightScales.connected;
    const context = truckData?.context;
    const lastActivity = formatTime(truckData?.lastActivityAt);
    const numberPlate = weightScales.truckNumberPlate || truckNumberPlate;

    if (!hubConnected && isNullEmptyOrWhitespace(numberPlate)) {
        return null;
    }

    return hubConnected ?
        (<div className={"alert alert-info"} role={"alert"}>
            <h5>Truck-proxy connected{numberPlate ? ` (${numberPlate})` : ''}</h5>
            {scaleConnected && 
                <p>Current scale weight: {weightScales.currentRawWeight} Kg / {weightScales.currentWeight} L</p>
            }

            {lastActivity && (
                <p className="mb-0"><small className="text-muted">Last activity from truck: {lastActivity}</small></p>
            )}

            {context && (
                <div className="mt-2">
                    <strong>Current Context:</strong>
                    <ul className="mb-0">
                        <li>Run: {context.runId || 'None'}</li>
                        <li>Pickup: {context.pickupId || 'None'}</li>
                        <li>Tank: {context.tankId || 'None'}</li>
                        <li>Type: {context.isCollectionRun ? 'Collection' : 'Delivery'}</li>
                        {context.setAt && <li>Set at: {formatTime(context.setAt)}</li>}
                    </ul>
                </div>
            )}
        </div>) :
        (<div className={"alert alert-warning"} role={"alert"}>
            <h5>Truck-proxy not connected{numberPlate ? ` (${numberPlate})` : ''}</h5>
            <p className="mb-0">Waiting for the truck device to come online. You don't need to connect to the truck wifi.</p>
        </div>);
};

ScaleStatusView.propTypes = {
    weightScales: PropTypes.object.isRequired,
    truckNumberPlate: PropTypes.string,
    truckData: PropTypes.object,
};

export default ScaleStatusView;
